import { useTrackDesignLabSessionStart } from "@design-lab/app/useTrackDesignLabSessionStart";

export function SessionStartTracker() {
  useTrackDesignLabSessionStart();
  return null;
}
